export default __webpack_public_path__ + "static/media/space.dfb3a57f.png";